define([
    "dojo/_base/lang",
    "../../../constants/TypeConstants",
    "../properties/TypeProperty",
    "../properties/TagProperty",
    "../properties/TextProperty",
    "../properties/TextOverrideProperty",
    "../properties/EnabledProperty",
    "../properties/DescriptionProperty",
    "../properties/DescriptionOverrideProperty",
    "../properties/MnemonicProperty",
    "../properties/ShortcutProperty",
    "../properties/ActionIdProperty",
    "../properties/ShowDescriptionProperty",
    "../properties/SelectedProperty",
    "../properties/ClosePopupOnClickProperty",
    "../properties/ButtonGroupNameProperty"

],
    function (lang, TypeConstants, TypeProperty, TagProperty, TextProperty, TextOverrideProperty, EnabledProperty,
              DescriptionProperty, DescriptionOverrideProperty, MnemonicProperty, ShortcutProperty, ActionIdProperty,
              ShowDescriptionProperty, SelectedProperty, ClosePopupOnClickProperty, ButtonGroupNameProperty) {
        var hash = {};

        hash[TypeConstants.LIST_ITEM_WITH_RADIO_BUTTON] = lang.mixin({}, {
            showText: {
                type: "boolean",
                defaultValue: true,
                notInAction: true,
                required: false
            }
        }, TypeProperty, TagProperty, TextProperty, TextOverrideProperty, EnabledProperty, DescriptionProperty,
            DescriptionOverrideProperty, MnemonicProperty, ShortcutProperty, ActionIdProperty,
            ShowDescriptionProperty, SelectedProperty, ClosePopupOnClickProperty, ButtonGroupNameProperty);

        return hash;
    });

